import { gql } from "@apollo/client";

export const cascoQuotationLite = gql`
  fragment cascoQuotationLite on CascoQuotationLite {
    productId
    conventionName
    insurerId
    insurerName
    period
    insuranceAmount
    totalInsuranceAmount
    currencyCode
  }
`;

export const rcaQuotationLite = gql`
  fragment rcaQuotationLite on RcaQuotationLite {
    insurerName
    period
    currencyCode
    details {
      insuranceAmount
      isDirectCompensation
    }
  }
`;
